import { pg } from "~/pg.server";
import { OurLoaderArgs } from "./Loaders";
import { stripRealm } from "./Lang";

export function logPageView(args: OurLoaderArgs) {
  if (DEV) {
    return;
  }
  const req = args.req;
  const realm = args.realm;
  const url = args.url;

  pg.db
    .insert(pg.pageViews)
    .values({
      ip: req.headers["x-real-ip"] as string,
      lang: realm.lang,
      gver: realm.game,
      userId: req.sess?.user.id,
      path: cleanUrl(url),
      userAgent: req.headers["user-agent"],
      referer: req.headers.referer,
    })
    .catch((err) => {
      console.error("PageView logging error:", err);
    });
}

function cleanUrl(url: URL): string {
  const searchParams = new URLSearchParams(url.searchParams);
  searchParams.delete("_data");

  const queryString = searchParams.toString();
  return stripRealm(
    queryString
      ? `${url.pathname}?${queryString}${url.hash}`
      : `${url.pathname}${url.hash}`
  );
}
